import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {ChatStartService} from './chat-start.service';

@Component({
    selector: 'mm-chatbot',
    templateUrl: './chatbot.component.html',
    styleUrls: ['./chatbot.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ChatbotComponent implements OnInit {
    @Input({required: true})
    public botId!: string;

    constructor(private chatStartService: ChatStartService) {
    }

    public ngOnInit(): void {
       this.chatStartService.start();
    }
}
